import { POSITION } from './position.interface';

export const MODAL_POISITION: POSITION = {
  centered: 'centered',
  fullScreen: 'full_screen',
};
